import { BackButton, BREAKPOINTS, TextButton as Button, COLORS, ComponentL, ComponentTextStyle, HyperLink, LoadingIndicator, PageWidth, Size, SystemIcons } from "@laerdal/life-react-components";

import styled from "styled-components";
import { caseTypeSubtypes } from "../../model/constants/CaseTypeSubtype";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { KnowledgeArticleListItemDto } from "../../model/dto/knowledgeArticleListItemDto";
import ArticleApi from "../../services/api/ArticleApi";
import Faqs from "../../commonComponents/Faqs";
import { PageWidthFull } from "../../commonComponents/PageWidthFull";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectMarket, selectTranslateWithAi } from "../../store/slices/globalConfigSlice";
import { marketList } from "../../model/constants/marketContants";
import UrgentAssistance from "../../commonComponents/UrgentAssistance";
import { CaseTitle, CaseSubTitle, CaseHeader } from "./components/CommonCaseComponents";


const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 32px 0;
`;



const FullWidth = styled.div`
  border-top: 1px solid ${COLORS.neutral_200};
  background: ${COLORS.neutral_20};
`

const Options = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const Side = styled.div`
    display: flex;
    flex-direction: column;
    gap:16px;
`

const Row = styled.div`
    display: flex;
    ${BREAKPOINTS.MEDIUM}{
        flex-direction: row;
        gap:64px
    }

    flex-direction: column;
    gap:8px
`
const UsfulArticles = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 64px;
`

const Link = styled(HyperLink)`
    border-radius: 4px;
    border: 1px solid var(--Neutral-200-tint, #CCC);
    background: var(--Base-White, #FFF);
    padding: 12px 20px 7px 20px;

    svg {
        vertical-align: middle;
        margin: 0 8px 4px 0;
    }
`;


const OptionCard = styled.div`
    border-radius: 8px;
    border: 1px solid var(--Neutral-200-tint, #CCC);
    background: var(--Base-White, #FFF);
    padding: 20px;
    cursor: pointer;

    color: var(--Base-Black, #1F1F1F);
    font-feature-settings: 'liga' off;
    overflow-wrap: break-word;
    white-space: normal;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    &:hover {
        background-color: var(--life-color-bg-surface-hover);
    }

    &:active {
        background-color: var(--life-color-bg-surface-active);
    }
`;

const CanNotSpecifyBtn = styled(Button)`
    align-self: start;
    margin: 16px 0;
`;


const CaseSuboptionsPage = () => {
    const { option } = useParams<{ option: string }>();
    const navigate = useNavigate();
    const { t } = useTranslation("cases");

    const caseType = caseTypeSubtypes.find((caseType) => caseType.value === option);

    const currentMartket = useSelector(selectMarket);
    const translateWithAi = useSelector(selectTranslateWithAi);




    return (
        <>
            <PageWidthFull $useMaxWidth={true} $maxWidth={1024} $unsetMargin={true}>
                <PageContainer>
                    <CaseHeader>
                        <BackButton size={Size.Small} onClick={() => window.history.back()}  >
                            {t('Back')}
                        </BackButton>
                        <CaseTitle>{t(caseType?.title ?? '')}</CaseTitle>
                        <CaseSubTitle>{t(caseType?.subtitle ?? '')}</CaseSubTitle>
                    </CaseHeader>

                    <Row>
                        <Options>
                            {caseType?.subtypes.map((subtype, index) => (
                                <OptionCard
                                    key={index}
                                    onClick={() => {
                                        if (!subtype.skipAssetSelection) {
                                            navigate(`/case/create/${caseType.value}/assetSelect?suboption=${subtype.value}`);
                                            return;
                                        }
                                        navigate(`/case/create/${caseType.value}/${subtype.value}`);
                                    }}
                                >
                                    {t(subtype.title)}
                                </OptionCard>
                            ))}
                            <CanNotSpecifyBtn variant="tertiary" onClick={() => navigate(`/case/create/unknown/unknown`)}>{t('Can not specify?')}</CanNotSpecifyBtn>
                        </Options>
                        <Side>
                            <Link variant="default" href="https://laerdal.com/support/catalog/" ><SystemIcons.ShoppingCart size="24px" />{t('Shop for parts, and accessories')}</Link>
                            {currentMartket == "us" &&
                                <Link variant="default" href="https://laerdal.com/support/scheduled-support/" ><SystemIcons.Educator size="24px" />{t('Schedule a call with technician')}</Link>
                            }
                        </Side>
                    </Row>
                </PageContainer>
            </PageWidthFull>
            <FullWidth>
                <PageWidth $useMaxWidth={true} $maxWidth={1024}>

                    <UrgentAssistance pageName="caseForm" />
                </PageWidth>
            </FullWidth>
        </>);
};

export default CaseSuboptionsPage;